module.exports = __webpack_public_path__ + "static/AvdHero-0d49bbbcc12455374d6980f1d5c27d61.png";